import React from 'react';
import PriceHistoryInterface from 'interfaces/price-history.interface';

const TrendIcon: React.FC<Pick<PriceHistoryInterface, 'trend'>> = props => {
    let iconType = '';

    switch (props.trend) {
        case 'increase':
            iconType = 'icon-chart-up';

            break;
        case 'decrease':
            iconType = 'icon-chart-down';

            break;
        default:
            iconType = 'icon-chart-const';
    }

    return (
        <i className={`icon ${iconType}`}/>
    );
};

export default TrendIcon;
